<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局基础重置 */
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background-color: var(--bg-frontend); /* 默认前台背景色 */
  color: var(--text-main);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* UI 规范变量 */
:root {
  --color-primary: #2563EB;
  --color-success: #10B981;
  --color-warning: #F59E0B;
  --color-danger: #EF4444;
  --bg-frontend: #F8FAFC;
  --bg-admin: #F1F5F9;
  --text-main: #1E293B;
  --text-secondary: #64748B;
  --border-color: #f8f5f5;
  --radius-card: 8px;
  --radius-btn: 6px;
  --radius-tag: 4px;
}
</style>
